import { takeLatest, select, call, put } from 'redux-saga/effects';

import getBlockTexts from '../../utils/getBlockTexts';

import spellCheck from '../../api/speller';

import { selectEditorBlocks, selectBlockByKey } from '../EditorContainer/selectors';

import { SPELL_CHECK_REQUESTED } from './constants';

import {
  spellCheckFailed,
  spellCheckSucceed,
} from './actions';

export function* spellCheckRequest({ payload = {} }) {
  let texts;

  if (payload.key) {
    const block = yield select(selectBlockByKey(payload.key));
    texts = getBlockTexts(block);
  } else {
    const blocks = yield select(selectEditorBlocks());
    texts = blocks.map(block => getBlockTexts(block)).toJS();
  }

  const response = yield call(spellCheck, texts);

  if (response.err) {
    yield put(spellCheckFailed(response.err, payload.key));
  } else {
    const data = Array.isArray(response.data) && Array.isArray(response.data[0])
      ? [].concat(...response.data)
      : response.data;
    yield put(spellCheckSucceed(data, payload.key));
  }
}

export function* spellCheckRoot() {
  yield takeLatest(SPELL_CHECK_REQUESTED, spellCheckRequest);
}

export default spellCheckRoot;
